import React, {  useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { updateConfigAI } from "redux/actions/configAI/configAiUpdate";
import Button from "shared/components/buttons/Button";
import InputText from "shared/components/inputs/InputText";
import { snackbarSuccess } from "shared/redux/actions/Snackbar";
import InputSelect from "shared/components/inputs/InputSelect";
import { loadConfigAI } from "redux/actions/configAI/configAiLoad";

import "./style.scss";

const ConfigAI = () => {


    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { osbn } = useParams();

    const { control, handleSubmit, errors, watch } = useForm();

    const { books } = useSelector(state => state.books);
    const { config } = useSelector(state => state.configAI);
    const { current: organisation } = useSelector(state => state.organisation);
    const [provider, setProvider] = useState("OpenAI");
    const [model, setModel] = useState("GPT-4");
    const book = books[osbn];

    const updateConfig = async ({ apikey = "", prompt }) => {
        const cleanedAiMap = stripTypename(config.aiMap || []);
        const configData = {
            id: config.id,
            organisationId: organisation.id,
            bookId: book.id,
            apikey,
            prompt,
            provider,
            model,
            osbn,
            aiMap: cleanedAiMap
        };

        dispatch(updateConfigAI(configData));
        dispatch(snackbarSuccess("AI configuration changes have been saved."));
    };

    const stripTypename = (obj) => {
        if (Array.isArray(obj)) {
            return obj.map(stripTypename);
        } else if (obj && typeof obj === "object") {
            const cleaned = {};
            for (const key in obj) {
                if (key === "__typename") continue;
                cleaned[key] = stripTypename(obj[key]);
            }
            return cleaned;
        }
        return obj;
    };

    useEffect(() => {
      
        //dispatch(loadConfigAI(book.id));
    }, [])

    
    if (!config) {
        return <></>
    }

    return (
        <div className="section-general">
            <h2>{t("book.edit.aiConfig.name")}</h2>
            <div className="divider" />

            <>
                <div className="cols-m">

                    <div className="col">
                        <InputSelect
                            items={[
                                { value: "OpenAI", label: "OpenAI" },

                            ]}
                            label={t("book.edit.aiConfig.provider")}
                            name="provider"
                            value={provider}
                            onChange={({ target }) => setProvider(target.value)}
                            disabled

                        />
                        <InputSelect
                            items={[
                                { value: "GPT-4", label: "GPT-4" },

                            ]}
                            label={t("book.edit.aiConfig.model")}
                            name="model"
                            value={model}
                            onChange={({ target }) => setModel(target.value)}
                            disabled
                        />
                        {/* <InputText
                            name="apikey"
                            label={t("book.aiConfig.apikey")}
                            defaultValue={config?.apikey || "This is your api key"}
                            control={control}
                            rules={{ required: true }}
                            error={errors.author}
                            dataTestId="author"
                        /> */}
                        {/* <InputText
                            name="prompt"
                            label={t("book.aiConfig.prompt")}
                            defaultValue={config.prompt}
                            control={control}
                            rules={{ required: true }}
                            error={errors.author}
                            dataTestId="author"
                            multiline
                        /> */}

                    </div>
                </div>
                <div className="divider" />
                <Button
                    label={t("button.save.label")}
                    onClick={handleSubmit(updateConfig)}
                />
            </>



        </div>
    );
};

export default ConfigAI;